import React, { Fragment } from 'react';

var Image = function Image(props) {
  var src = props.src,
      srcSet = props.srcSet,
      sizes = props.sizes,
      sources = props.sources,
      alt = props.alt,
      isZoomed = props.isZoomed,
      fadeDuration = props.fadeDuration;
  return React.createElement(Fragment, null, sources && sources.length > 0 ? React.createElement('picture', null, sources.map(function (source, i) {
    return React.createElement(Fragment, {
      key: i
    }, source.srcSet && React.createElement('source', {
      srcSet: source.srcSet,
      sizes: source.sizes,
      media: source.media,
      type: source.type
    }));
  }), React.createElement('img', {
    className: 'iiz__img ' + (isZoomed ? 'iiz__img--invisible' : ''),
    style: {
      transition: 'linear 0ms opacity ' + (isZoomed ? fadeDuration : 0) + 'ms, linear ' + fadeDuration + 'ms visibility ' + (isZoomed ? fadeDuration : 0) + 'ms'
    },
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    alt: alt
  })) : React.createElement('img', {
    className: 'iiz__img ' + (isZoomed ? 'iiz__img--invisible' : ''),
    style: {
      transition: 'linear 0ms opacity ' + (isZoomed ? fadeDuration : 0) + 'ms, linear ' + fadeDuration + 'ms visibility ' + (isZoomed ? fadeDuration : 0) + 'ms'
    },
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    alt: alt
  }));
};

export default Image;